module.exports = __webpack_public_path__ + "static/img/13023B_4_R_20200317_fit.aba721c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/13023B_4_R_20200317_fit.png
// module id = u6w3
// module chunks = 0